import { apiFetch } from 'services/apiClient';
import { Group } from '../types/Group';

export const listGroupsAll = (query?: string): Promise<Group[]> => apiFetch('/groups/all' + (query ? ('?' + query) : ''));
export const getGroup = (id: number): Promise<Group> => apiFetch('/groups/' + id);
export const createGroup = (data: any): Promise<Group> =>
  apiFetch('/groups', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) });
export const updateGroup = (id: number, data: any): Promise<Group> =>
  apiFetch('/groups/' + id, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) });
export const deleteGroup = (id: number): Promise<void> =>
  apiFetch('/groups/' + id, { method: 'DELETE' });

export const reorderGroups = (items: Array<{ id: number; sortOrder: number }>): Promise<void> =>
  apiFetch('/groups/reorder', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(items),
  });
